import React from 'react';
import { Button } from '../ui/button';
import { Stack, SpinnerGap, User, CalendarBlank, IdentificationCard, Globe } from '@phosphor-icons/react';
import { TemplateWithDate, FormField } from './FormFields';

export const AllTab = ({
  allForm, setAllForm, isAdmin, isGeneratingAll,
  verificationTemplates, contractTemplates, employmentTemplates,
  onGenerateAll
}) => (
  <div className="border border-[#262626] bg-[#141414]">
    <div className="p-4 border-b border-[#262626]">
      <h2 className="text-xs uppercase tracking-[0.2em] font-semibold text-[#A3A3A3]">Создать все документы</h2>
      <p className="text-xs text-[#525252] mt-1">Выберите шаблоны, укажите даты и заполните данные</p>
    </div>
    <div className="p-4 space-y-4">
      <div className="space-y-3">
        {verificationTemplates.length > 0 && (
          <TemplateWithDate templates={verificationTemplates} selectedId={allForm.verificationTemplateId}
            onSelect={(v) => setAllForm(p => ({...p, verificationTemplateId: v}))}
            date={allForm.verificationDate} onDateChange={(d) => setAllForm(p => ({...p, verificationDate: d}))}
            label="Шаблон верификации" testIdPrefix="all-verification" />
        )}
        {contractTemplates.length > 0 && (
          <TemplateWithDate templates={contractTemplates} selectedId={allForm.contractTemplateId}
            onSelect={(v) => setAllForm(p => ({...p, contractTemplateId: v}))}
            date={allForm.contractDate} onDateChange={(d) => setAllForm(p => ({...p, contractDate: d}))}
            label="Шаблон контракта" testIdPrefix="all-contract" />
        )}
        {employmentTemplates.length > 0 && (
          <TemplateWithDate templates={employmentTemplates} selectedId={allForm.employmentTemplateId}
            onSelect={(v) => setAllForm(p => ({...p, employmentTemplateId: v}))}
            date={allForm.employmentDate} onDateChange={(d) => setAllForm(p => ({...p, employmentDate: d}))}
            label="Шаблон трудового договора" testIdPrefix="all-employment" />
        )}
        {verificationTemplates.length === 0 && contractTemplates.length === 0 && employmentTemplates.length === 0 && (
          <div className="text-center py-6 text-[#525252]">
            <p className="text-sm">Нет шаблонов. {isAdmin ? 'Загрузите в Настройках.' : 'Обратитесь к администратору.'}</p>
          </div>
        )}
      </div>
      <div className="border-t border-[#262626]" />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField icon={User} label="ФИО" value={allForm.fullName}
          onChange={(v) => setAllForm(p => ({...p, fullName: v}))} placeholder="IVANOV IVAN" testId="all-name" />
        <FormField icon={CalendarBlank} label="Дата рождения" value={allForm.dateOfBirth}
          onChange={(v) => setAllForm(p => ({...p, dateOfBirth: v}))} placeholder="01.01.2000" testId="all-dob" />
        <FormField icon={IdentificationCard} label="Паспорт / ID" value={allForm.passportId}
          onChange={(v) => setAllForm(p => ({...p, passportId: v}))} placeholder="AA1234567" testId="all-passport" />
        <FormField icon={Globe} label="Национальность / Страна" value={allForm.nationality}
          onChange={(v) => setAllForm(p => ({...p, nationality: v}))} placeholder="UZBEKISTAN" testId="all-nationality" />
      </div>
    </div>
    <div className="p-4 border-t border-[#262626]">
      <Button onClick={onGenerateAll} disabled={isGeneratingAll}
        className="w-full h-12 bg-[#FACC15] hover:bg-[#EAB308] text-[#0A0A0A] font-semibold rounded-none disabled:opacity-50"
        data-testid="generate-all-btn">
        {isGeneratingAll ? <><SpinnerGap size={20} className="animate-spin mr-2" />Генерация...</>
          : <><Stack size={20} className="mr-2" weight="bold" />Создать все документы</>}
      </Button>
    </div>
  </div>
);
